import GateKeeperMiddleware from '@/middleware/GateKeeperMiddleware.js';

export default [
    {
        path: '/activity-log',
        component: () => import('@/pages/activity-log/ActivityLogIndex.vue'),
        props: true,
        children: [
            {
                name: 'activity-log-index',
                path: '',
                component: () => import('@/components/activity-log/ActivityLog.vue'),
                meta: {
                    title: 'Activity Log',
                    middleware: [GateKeeperMiddleware],
                    ability: { action: 'view', subject: 'activity log' },
                    dataTablePage: true,
                },
                props: true,
            },
        ],
    },
];
